import { useEffect, useState } from "react"
import { db } from "../firebase/config"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { useRef } from "react"



export const useCollection = (c,_q) =>{

  const [scores, setScores] = useState(null)

  const q = useRef(_q).current

  useEffect(()=>{

    let ref = collection(db,c)

    if(q){
      ref = query(ref, where(...q))
    }

    const unsub = onSnapshot(ref, (snapshot)=>{

      let results = []

      snapshot.docs.forEach((doc)=>{
        results.push({...doc.data()})
      })

      if(!results.length==0){
        setScores(results)
      }
     
    })

      
      
        
    return () => unsub()

  },[])

  return { scores }

}